export const potensiTingkatKeparahanItem = [
  { key: "1", name: "Insignificant", value: "Insignificant" },
  { key: "2", name: "Minor", value: "Minor" },
  { key: "3", name: "Moderate", value: "Moderate" },
  { key: "4", name: "Significant", value: "Significant" },
  { key: "5", name: "Catastrophic", value: "Catastrophic" },
  { key: "", name: "", value: "" },
];

export const potensiKejadianItem = [
  { key: "1", name: "1", value: "1" },
  { key: "2", name: "2", value: "2" },
  { key: "3", name: "3", value: "3" },
  { key: "4", name: "4", value: "4" },
  { key: "5", name: "5", value: "5" },
  { key: "0", name: "", value: "0" },
];
